export default __webpack_public_path__ + "static/media/039-door.8db5ab42.svg";